<script lang='ts' setup>
import { ref, computed } from 'vue'
import RoomieChipSelector from '@lahaus-roomie/roomie/src/components/RoomieChipSelector/index.vue'

import type { Props } from './types'
import AppBubbleAuthor from '@/components/App/Chat/BubbleAuthor/index.vue'
import { useUserStore } from '@/stores/userStore'
import { getReferralBonus } from '@/utils/referralBonus'

import './_index.scss'

defineProps<Props>()

const userStore = useUserStore()
const { t, locale } = useI18n()

const bonusWithCurrency = computed(() => getReferralBonus(locale.value, true))

const getReferalLink = () => {
  const url = new URL(window.location.href)
  url.searchParams.set('utm_source', 'mgm')
  if (userStore.user?.id) url.searchParams.set('referrer_id', userStore.user.id)
  return url.href
}

const copyToClipboard = () => {
  const referalLink = getReferalLink()
  navigator.clipboard.writeText(referalLink)
  alert('Enlace copiado al portapapeles')
}

const shareWhatsapp = () => {
  const referalLink = getReferalLink()
  const shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(referalLink)}`
  window.open(shareUrl, '_blank')
}

const shareUrlByEmail = () => {
  const subject = 'Te comparto esto'
  const referalLink = getReferalLink()
  const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(referalLink)}`
  window.open(mailtoLink, '_blank')
}

const shareButtons = [
  {
    id: 'whatsapp',
    text: t('shareMethods.whatsapp'),
    action: shareWhatsapp
  },
  {
    id: 'email',
    text: t('shareMethods.email'),
    action: shareUrlByEmail

  },
  {
    id: 'link',
    text: t('shareMethods.link'),
    action: copyToClipboard
  }
]

const selectedShareButton = ref<number>()
const handleShareButtonSelect = (idx: number) => {
  selectedShareButton.value = idx
  setTimeout(() => shareButtons[idx].action(), 500)
}

</script>

<script lang='ts'>
export default {
  name: 'AppChatReferralSection'
}
</script>

<template>
  <section class="app-chat-referral-section">
    <section class="app-chat__bubbles app-chat__author-bot">
      <p>
        {{ helperText }}
      </p>

      <div class="flex flex-col items-center text-center">
        <img
          src="https://media.lahaus.com/statics/roomie/pictograms/gift.svg"
          alt="icono seguridad"
          class="w-82 h-82 mb-16">

        <h3
          v-sanitize="t('winMoneyText', { bonusWithCurrency })"
          class="text-20 text-primary-800" />
      </div>

      <div class="flex flex-col gap-16 mt-24">
        <RoomieChipSelector
          v-for="button, idx in shareButtons"
          :id="`app-chat-share-button-${button.id}`"
          :key="`app-chat-message-button-${button.id}`"
          :data-lh-id="`app-chat-share-button-${button.id}`"
          class="app-chat-share-button__chip-selector"
          :label="button.text"
          :is-selected="selectedShareButton === idx"
          @click="handleShareButtonSelect(idx)">
          <template #content>
            <p class="text-14 pointer-events-none">
              {{ button.text }}
            </p>
          </template>
        </RoomieChipSelector>
      </div>
    </section>

    <AppBubbleAuthor
      :author="'bot'"
      :bot-name />

    <section class="app-chat__bubbles app-chat__author-bot">
      <p v-sanitize="t('secondGreetingMessage')" />
    </section>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
